/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

export const ENTER = 13;
export const SPACE = 32;
export const ESCAPE = 27;
export const TAB = 9;
export const BACKSPACE = 8;
export const F2 = 113;

// Arrow keys
export const DOWN = 40;
export const UP = 38;
export const LEFT = 37;
export const RIGHT = 39;

export const PAGE_UP = 33;
export const PAGE_DOWN = 34;
export const END = 35;
export const HOME = 36;

export enum keyCodes {
  ENTER = 13,
  SPACE = 32,
  ESCAPE = 27,
  TAB = 9,
  BACKSPACE = 8,
  F2 = 113,

  DOWN = 40,
  UP = 38,
  LEFT = 37,
  RIGHT = 39,

  PAGE_UP = 33,
  PAGE_DOWN = 34,
  END = 35,
  HOME = 36,
}
